export default `
  mutation GenerateRememberMeToken {
    generateRememberMeToken {
      token
    }
  }
`;
